<template>
  <v-layout row>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-list two-line>
          <v-list-group
            v-for="item in items"
            v-model="item.active"
            :key="item.title"
            no-action
          >

            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile
              v-for="subItem in item.items"
              :key="subItem.title"
              @click=""
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-icon>{{ subItem.action }}</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>


<script>
  export default {
    data () {
      return {
        items: [
          {
            title: 'Nouns',
            items: [
              { title: 'Inflection' },
              { title: 'Compound Nouns' },
              { title: 'Initial Mutation' },
              { title: 'Verbal Noun' }
            ]
          },
          {
            title: 'Verbs',
            items: [
              { title: 'List Item' }
            ]
          },
          {
            title: 'Prepositions',
            items: [
              { title: 'List Item' }
            ]
          },
          {
            title: 'Copula',
            items: [
              { title: 'List Item' }
            ]
          },
          {
            title: 'Adjectives',
            items: [
              { title: 'List Item' }
            ]
          },
          {
            title: 'Numerals',
            items: [
              { title: 'List Item' }
            ]
          },
          {
            title: 'Pronouns',
            items: [
              { title: 'List Item' }
            ]
          },
          {
            title: 'Relative Clauses',
            items: [
              { title: 'List Item' }
            ]
          },
          {
            title: 'Sentence Structure',
            items: [
              { title: 'List Item' }
            ]
          },
          {
            title: 'Meter and Prosody',
            items: [
              { title: 'List Item' }
            ]
          },
          
        ]
      }
    }
  }
</script>


<style scoped>
</style>
